export default __webpack_public_path__ + "static/media/map.974139fa.png";